import { ReadOnlyEditorLanguage } from "components/ReadOnlyEditor";

import { Sdk } from "./config";
// Cloud snippets
import cloudDotnetSnippet from "./snippets/cloud/dotnet.cs?raw";
import cloudGoSnippet from "./snippets/cloud/go.go?raw";
import cloudJdbcSnippet from "./snippets/cloud/jdbc.java?raw";
import cloudNodeSnippet from "./snippets/cloud/node?raw";
import cloudPythonSnippet from "./snippets/cloud/python.py?raw";
// Core snippets
import coreDotnetSnippet from "./snippets/core/dotnet.cs?raw";
import coreGoSnippet from "./snippets/core/go.go?raw";
import coreJdbcSnippet from "./snippets/core/jdbc.java?raw";
import coreNodeSnippet from "./snippets/core/node?raw";
import corePythonSnippet from "./snippets/core/python.py?raw";

const isLite = Boolean(process.env.REACT_APP_LITE);

export type UsageContext = {
  accountName?: string;
  databaseName: string;
  engineName?: string;
  serviceAccountId?: string;
  serviceAccountSecret?: string;
};

export type UsageSnippet = {
  code: string;
  language: ReadOnlyEditorLanguage;
};

const escapeDoubleQuotes = (value: string) =>
  value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');

const PLACEHOLDER_MAP: Record<string, keyof UsageContext> = {
  your_service_account_id: "serviceAccountId",
  your_account_name: "accountName",
  your_database_name: "databaseName",
  your_engine_name: "engineName",
};

export const replacePlaceholders = (
  template: string,
  context: UsageContext
): string => {
  let result = template;

  for (const [placeholderKey, contextKey] of Object.entries(PLACEHOLDER_MAP)) {
    const value = context[contextKey];
    if (value) {
      const escapedValue = escapeDoubleQuotes(value);

      result = result.replace(
        new RegExp(`\\b${placeholderKey}\\b`, "g"),
        escapedValue
      );
    }
  }

  return result;
};

export const INSTALL_COMMANDS: Record<Sdk, string> = {
  [Sdk.Jdbc]: "mvn dependency:get -Dartifact=com.firebolt:firebolt-jdbc:latest",
  [Sdk.Python]: "pip install firebolt-sdk",
  [Sdk.Dotnet]: "dotnet add package FireboltDotNetSdk",
  [Sdk.Go]: "go get github.com/firebolt-db/firebolt-go-sdk",
  [Sdk.Node]: "npm install firebolt-sdk",
};

export const SNIPPET_CONFIG: Record<
  Sdk,
  { template: string; language: ReadOnlyEditorLanguage }
> = {
  [Sdk.Jdbc]: {
    template: isLite ? coreJdbcSnippet : cloudJdbcSnippet,
    language: "java",
  },
  [Sdk.Python]: {
    template: isLite ? corePythonSnippet : cloudPythonSnippet,
    language: "python",
  },
  [Sdk.Dotnet]: {
    template: isLite ? coreDotnetSnippet : cloudDotnetSnippet,
    language: "csharp",
  },
  [Sdk.Go]: {
    template: isLite ? coreGoSnippet : cloudGoSnippet,
    language: "go",
  },
  [Sdk.Node]: {
    template: isLite ? coreNodeSnippet : cloudNodeSnippet,
    language: "javascript",
  },
};
